import React from 'react';

import { LeftOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import { useNavigate, useNavigationType } from 'react-router-dom';

export interface BackButtonProps extends ButtonProps {
  to: string;
  text?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ to, text, ...props }) => {
  const navigate = useNavigate();
  const navigationType = useNavigationType();

  const handleBack = () => {
    if (navigationType === 'POP') {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  const handleMouseDown = (event: React.MouseEvent) => {
    if (event.button === 1) {
      window.open(to, '_blank');
    }
  };

  return (
    <Button icon={<LeftOutlined />} onClick={handleBack} onMouseDown={handleMouseDown} {...props}>
      {text || 'Назад'}
    </Button>
  );
};
